import './PeriscopeTitle.scss';

import { ActiveIndicator } from '@ui/icons';
import { FlexFiller } from '@ui/FlexFiller';
import { FollowButton } from './FollowButton';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { isEmpty } from 'lodash';
import { PeriscopeInitiatives } from './PeriscopeInitiatives';
import { Space } from 'antd';
import Tooltip from 'antd/es/tooltip';
import { useCurrentUser } from '@hooks';
import { VersionNumber } from '@ui/VersionNumber';
import { When } from 'react-if';

import { COPY_SPECIFIC, ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { PeriscopeSummary, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

function showAddToInitiatives(type: SonarObjectType, isReadOnly: boolean): boolean {
	const source = getSonarObjectTypeSourceLabel(type);

	return source !== ORGANIZATION_TYPE_LABELS.SONAR && !isReadOnly;
}

export interface PeriscopeTitleProps {
	data: PeriscopeSummary;
}

export const PeriscopeTitle: React.FC<PeriscopeTitleProps> = ({ data }) => {
	const { isReadOnly } = useCurrentUser();
	const { internalName, displayName, isActive, sonarObjectId, sonarObjectType, versionNumber } = data;
	const showInitiatives = useMemo(
		() => showAddToInitiatives(sonarObjectType, isReadOnly),
		[ isReadOnly, sonarObjectType ]
	);

	return (
		<div className='periscope-title'>
			<div className='periscope-title-name'>
				<Tooltip
					open={ isEmpty(internalName) ? false : undefined }
					placement='bottom'
					title={ `${COPY_SPECIFIC.API_NAME}: ${internalName}` }>
					<span>{ displayName }</span>
				</Tooltip>
				<VersionNumber number={ versionNumber } />
			</div>
			<ActiveIndicator isActive={ isActive } />
			<FlexFiller />
			<Space>
				<When condition={ showInitiatives }>
					<PeriscopeInitiatives sonarObjectId={ sonarObjectId } />
				</When>
				<When condition={ sonarObjectType !== SonarObjectType.SalesforceReport }>
					<FollowButton sonarObjectIds={ [ sonarObjectId ] } />
				</When>
			</Space>
		</div>
	);
};
